import { useState, useCallback } from 'react'

// Multi-purpose toggle hook
export const useToggle = (
  initialValue = false
): {
  value: boolean
  toggleValue: () => void
  setValue: (value: boolean) => void
} => {
  const [value, setValue] = useState<boolean>(initialValue)

  const toggleValue = useCallback(() => {
    setValue((value) => !value)
  }, [])

  return { value, toggleValue, setValue }
}
